import { faSmile as faSmileOutlined } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dynamic from 'next/dynamic';
import React, { RefObject } from 'react';
import VyPopoverMenu from '../common/VyPopoverMenu';

const EmojiPicker = dynamic(() => import('./EmojiPicker'), {
  ssr: false,
});

interface ChatEmojisInterface {
  chatInputRef?: RefObject<any>;
  bottom?: number;
  iconColor?: string;
  value?: string;
  closeOnChange?: boolean;
  onChange?: (value: string) => void;
}
const ChatEmojis = ({ chatInputRef, bottom = 30, value, iconColor = 'text-white', closeOnChange = false, onChange }: ChatEmojisInterface) => {
  function onEmojiClick(value: any, cb?: () => void) {
    if (!chatInputRef) {
      onChange?.(value);
    } else {
      const input = chatInputRef!.current!;
      chatInputRef!.current!.value = value;
      onChange?.(chatInputRef!.current!.value);
    }
    cb?.();
  }

  return (
    <VyPopoverMenu
      transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      content={(onClose) => (
        <div style={{ height: '435px', width: '352px' }}>
          <EmojiPicker onEmojiSelect={({ native }) => onEmojiClick(native, onClose)} />
        </div>
      )}>
      <div className="cursor-pointer" style={{ color: iconColor }}>
        {value && <p>{value}</p>}
        {!value && <FontAwesomeIcon size="lg" className={iconColor} icon={faSmileOutlined} />}
      </div>
    </VyPopoverMenu>
  );
};

export default ChatEmojis;
